module.exports = __webpack_public_path__ + "static/media/ItMakesSenseToBelieve.386c6d6a.jpg";